import React from 'react';
import { Notification } from "baseui/notification";

import useBrowserWarning from './useBrowserWarning'; // Import the hoo
import { ReactComponent as InfoBannerIconSvg } from "../../assets/img/info-banner-icon.svg";
import './index.scss';

/**
 * This component will display a warning message if the user is using an unsupported browser.
 * @returns {JSX.Element} The browser warning message.
 */
const BrowserWarning = () => {
    const isSupportedBrowser = useBrowserWarning();

    return (
        <>
            {isSupportedBrowser ? null : (
                <Notification closeable overrides={{
                    Body: { style: { width: "auto", alignItems: "center" } },
                }}>
                    <div className='browser-warning'>
                        <span>
                            <InfoBannerIconSvg title="Information Banner" />
                        </span>
                        <p>Some features might not work in your current browser.
                            Please use <b>Google Chrome</b>, <b>Safari</b>, <b>Mozilla Firefox</b> or <b>Microsoft Edge</b> for the best experience.
                        </p>
                    </div>
                </Notification>
            )}
        </>
    );
};

export default BrowserWarning;
